import { HttpInterceptorFn } from '@angular/common/http';

/**
 * interceptors
 */
import { errorInterceptor } from '../error';
import { bypassInterceptor } from '../bypass';
import { loadingInterceptor } from '../loading';
import { jwtInterceptor } from '../jwt/jwt.interceptor';
import { appRequestInterceptor } from '../app-request/app-request.interceptor';
import { sessionHttpAbortInterceptor } from '../session-http-abort';
import { toastrInterceptor } from '../toastr';

/**
 * Array of HTTP interceptor functions
 * @constant {HttpInterceptorFn[]} httpInterceptors
 * @description Array of functional HTTP interceptors for the application.
 * Provides automatic JWT token injection, error handling, and other HTTP-related functionality.
 * 
 * @example
 * ```typescript
 * // In your app.config.ts
 * import { provideHttpClient, withInterceptors } from '@angular/common/http';
 * import { httpInterceptors } from '@core/interceptors/http/providers';
 * 
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideHttpClient(
 *       withInterceptors(httpInterceptors)
 *     ),
 *     // other providers
 *   ]
 * };
 * ```
 * 
 * @since 1.0.0
 * @author SADIN Development Team
 */
export const httpInterceptors: HttpInterceptorFn[] = [
  bypassInterceptor,
  jwtInterceptor,
  appRequestInterceptor,
  sessionHttpAbortInterceptor,
  toastrInterceptor,
  errorInterceptor,
  loadingInterceptor,
];
